import BenefitsNew from 'lowcode/OldMember/BenefitsNew';
import { Fragment, useEffect, useState } from 'react';
import './index.scss';
import { getIsLogin } from 'lowcode/utils/getIsLogin';

export default function Content() {
    const [isLogin, setIsLogin] = useState(false);

    useEffect(() => {
        const isLogin2 = getIsLogin();
        setIsLogin(isLogin2);
    }, []);

    return (
        <Fragment>
            <BenefitsNew isLogin={isLogin} />
        </Fragment>
    );
}
